export default __webpack_public_path__ + "static/media/icon-instagram.ac52fcd5.svg";